<template>
  <div class="floor-link-components">
    <div class="floor-link">
      <el-carousel trigger="click" height="138px" arrow="never" :autoplay="false"
                   :indicator-position="linkList && linkList.length > 1 ? 'outside' : 'none'">
        <el-carousel-item v-for="(item, index) in linkList" :key="index">
          <div class="link-page">
            <a class="page-item"
               :href="img.url"
               target="_blank"
               v-for="(img, indexImg) in item" :key="indexImg"
               :style="{backgroundImage: `url('${img.filedPath}')`, backgroundColor: `${img.defaultImage}`}">{{img.filedPath ? '' : img.name}}</a>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FloorLink',
  props: {
    floor: {
      type: Array,
      default () {
        return []
      },
    },
  },
  computed: {
    linkList () {
      const temp = []
      if (this.floor?.length > 0) {
        for (let i = 0; i < Math.ceil(this.floor.length / 5); i++) {
          temp.push(this.floor.slice(i, i + 5))
        }
      }
      return temp
    },
  },
}
</script>

<style lang="scss">
.floor-link-components {
  margin-top: 26px;
  width: 100%;

  .floor-link {
    width: 1200px;
  }

  .link-page {
    font-size: 0;

    .page-item {
      margin-right: 20px;
      display: inline-block;
      vertical-align: middle;
      text-align: center;
      line-height: 138px;
      width: 224px;
      height: 138px;
      padding: 0 16px;
      border-radius: 6px;
      overflow: hidden;
      box-sizing: border-box;
      font-size: 24px;
      font-weight: bold;
      box-shadow: 0 0 6px 0 rgba(156, 156, 156, 0.06);
      background-repeat: no-repeat;
      background-position: center center;
      background-size: auto;
      color: #fff;

      &:last-child {
        margin-right: 0;
      }
    }
  }

  .el-carousel__indicators--outside {
    padding-top: 18px;
  }

  .el-carousel__indicator--horizontal {
    .el-carousel__button {
      width: 25px;
      height: 5px;
      border-radius: 2.5px;
      background: #D2E7F3;
      opacity: 1;
    }

    &.is-active {
      .el-carousel__button {
        width: 36px;
        background: $--color-primary;
      }
    }
  }
}
</style>
